<div class="main_header_div">
    <h3 mat-dialog-title class="mat-title"><img class="header-icon mr-3" src="assets/icons/rtf.png">Delete Feedback</h3>
    <div class="pr-3">
        <img class="close-icon" (click)="closeDialog('No')" src="assets/icons/close.png">
    </div> 
</div>
<hr/>
<div>
    <div>
        <p class="paragraph">{{dialogText}}</p>
    </div>

  <div>
    <button class="cancel" (click)="closeDialog('No')">Cancel</button>
    <button class="delete" (click)="closeDialog('Yes')">Delete</button>
  </div>
</div>
